import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleAuthProviderComponent } from "./contexts/GoogleAuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { BrowserRouter } from "react-router-dom";

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <GoogleAuthProviderComponent>
          <App />
        </GoogleAuthProviderComponent>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);